import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import tokens from './tokens';

export const theme = tokens;

export const ThemeProvider = ({ children }) => (
  <StyledThemeProvider theme={theme}>
    {children}
  </StyledThemeProvider>
);

export default ThemeProvider;
